<template>
  <div :class="[ 'flex gap-x-5 gap-y-2.5', vertical ? 'flex-col' : 'flex-wrap' ]">
    <label
      v-for="option in options"
      :key="String(option.value)"
      :class="[ 'flex w-fit items-center gap-2 text-sm text-foreground', disabled || option.disabled ? 'cursor-not-allowed' : 'cursor-pointer' ]"
    >
      <ui-checkbox
        :model-value="modelValue.includes(option.value)"
        :disabled="disabled || option.disabled"
        @update:model-value="(checked) => toggle(option.value, checked)"
      />
      {{ option.label }}
    </label>
  </div>
</template>

<script>
/**
 * Checkbox group bound to an array (like several native checkboxes sharing a
 * v-model). Options: { value, label, disabled }.
 */
export default {
  name: 'CheckboxList',
  props: {
    modelValue: {
      type: Array,
      required: true,
    },
    options: {
      type: Array,
      required: true,
    },
    vertical: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: () => false,
    },
  },
  emits: [ 'update:modelValue' ],
  methods: {
    toggle(value, checked) {
      this.$emit('update:modelValue', checked
        ? [ ...this.modelValue, value ]
        : this.modelValue.filter(item => item !== value));
    },
  },
};
</script>
